var map = {
	"./slide_1_en.png": "malj",
	"./slide_1_fr.png": "vopL",
	"./slide_2_en.png": "iOgM",
	"./slide_2_fr.png": "qAmX",
	"./slide_3_en.png": "DKqG",
	"./slide_3_fr.png": "hdb0",
	"./slide_4_en.png": "ShP8",
	"./slide_4_fr.png": "2E/4",
	"./slide_5_en.png": "DWo3",
	"./slide_5_fr.png": "Pp9W",
	"./slide_6_en.png": "5Evr",
	"./slide_6_fr.png": "xEBQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "q2NO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider ^\.\/slide_.*\.png$
// module id = q2NO
// module chunks = 0